import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';
import App from './App.vue';
import router from './router';
import store from './store';
// eslint-disable-next-line import/prefer-default-export
export const eventBus = new Vue();

Vue.config.productionTip = false;
smoothscroll.polyfill();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
